import type { TocItem } from "@/components/legal/LegalLayout";

export const PRIVACY_EFFECTIVE_DATE = "August 18, 2026";
export const PRIVACY_LAST_UPDATED = "August 12, 2026";

// The deployed revision of this document: counsel's Last Updated date, plus a
// suffix when Benmore corrects the deployed copy without a new counsel
// document (scripts/legal/README.md lists the corrections). Bumping it makes
// every existing user accept again, so it must stay identical to
// LEGAL_DOCUMENT_VERSIONS in backend/config/settings/base.py.
export const PRIVACY_VERSION = "2026-08-12-r2";

export const PRIVACY_TOC: TocItem[] = [
  { id: "section-1", label: "1. SCOPE AND OVERVIEW" },
  { id: "section-2", label: "2. PERSONAL INFORMATION WE COLLECT" },
  { id: "section-3", label: "3. HOW WE USE PERSONAL INFORMATION" },
  { id: "section-4", label: "4. HOW WE DISCLOSE PERSONAL INFORMATION" },
  { id: "section-5", label: "5. COOKIES, TRACKING TECHNOLOGIES, AND COMMUNICATION CHOICES" },
  { id: "section-6", label: "6. DATA RETENTION, DISCONNECTION, AND DELETION" },
  { id: "section-7", label: "7. DATA SECURITY" },
  { id: "section-8", label: "8. YOUR ACCOUNT CONTROLS" },
  { id: "section-9", label: "9. U.S. STATE PRIVACY RIGHTS" },
  { id: "section-10", label: "10. FINANCIAL INFORMATION PRACTICES" },
  { id: "section-11", label: "11. THIRD-PARTY SERVICES AND LINKS" },
  { id: "section-12", label: "12. CHILDREN AND ELIGIBILITY" },
  { id: "section-13", label: "13. U.S. PROCESSING" },
  { id: "section-14", label: "14. CHANGES TO THIS POLICY" },
  { id: "section-15", label: "15. CONTACT US" },
];

/**
 * The section a "how to delete your data" link should land on, found by what the
 * section IS rather than by its number (BEN-141 L2). The Landing FAQ hard-coded
 * section-7, and counsel's renumbered policy made §7 "DATA SECURITY"; deletion is
 * the section whose heading names it.
 */
export const PRIVACY_DELETION_SECTION = PRIVACY_TOC.find((s) => /\bDELETION\b/.test(s.label))?.id;
